var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEma4(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Confident"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M44 21.9997C44 34.1497 34.1811 43.9995 22.0693 43.9995C9.95751 43.9995 0.138641 34.1497 0.138641 21.9997C0.138641 9.84931 9.95751 0 22.0693 0C34.1811 0 44 9.84979 44 21.9997Z",
    fill: "#FFE14D"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M4.66219 22.087C4.35349 9.93561 9.81023 3.66318 19.1639 0.17395C8.35794 1.53882 0 10.79 0 21.9998C0 34.1503 9.81887 44 21.9307 44C23.9543 44 25.913 43.7236 27.7734 43.2088C26.8675 43.3229 25.9428 43.4298 25.0071 43.3822C14.9765 42.8702 4.97089 34.2331 4.66219 22.087Z",
    fill: "#FFBB33"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M14.8198 25.0864C14.8198 25.0864 17.8641 28.3179 21.9862 28.1075C24.4462 27.9827 26.7146 26.7026 27.6599 26.0086C31.5904 23.1214 29.2548 32.8927 20.3294 31.4094C12.535 30.1138 12.6872 24.6134 14.8198 25.0864Z",
    fill: "#802E19"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M6.82725 21.3711C6.82725 21.3711 8.90846 19.162 11.7266 19.305C13.4084 19.3907 14.9591 20.2658 15.6053 20.7407C18.2924 22.7148 17.1454 15.1088 11.0439 16.1226C5.71488 17.0082 5.36921 21.6938 6.82725 21.3711Z",
    fill: "#802E19"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M36.2449 21.3711C36.2449 21.3711 34.1637 19.162 31.3456 19.305C29.6638 19.3907 28.1131 20.2658 27.4669 20.7407C24.7798 22.7148 25.9267 15.1088 32.0282 16.1226C37.3573 17.0082 37.703 21.6938 36.2449 21.3711Z",
    fill: "#802E19"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M6.54239 12.7271C6.54239 12.7271 7.27933 12.5301 8.34802 12.3177C9.79118 12.0297 11.8397 11.7147 13.4903 11.8183C16.3632 11.9984 14.3065 8.99077 9.35142 10.0888C4.39685 11.1874 5.26246 13.0281 6.54239 12.7271Z",
    fill: "#802E19"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_7",
    d: "M35.511 12.233C35.511 12.233 34.7741 12.0365 33.7054 11.8236C32.2622 11.5361 30.2137 11.2206 28.5631 11.3242C25.6902 11.5043 27.7469 8.49669 32.702 9.59475C37.6565 10.6938 36.7909 12.534 35.511 12.233Z",
    fill: "#802E19"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEma4);
export default __webpack_public_path__ + "static/media/ema4.d07bc61acea0f2d87ccaf81aa6a4051e.svg";
export { ForwardRef as ReactComponent };